import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import type { ScrollStates } from './content-scroll/content-scroll.types';

@Injectable()
export class ScrollStateService {
  public scrollStates: BehaviorSubject<ScrollStates[]> = new BehaviorSubject<
    ScrollStates[]
  >([]);

  public constructor() {}
  public updateScrollState(state: ScrollStates): void {
    const states = this.scrollStates.value;
    states.map((value) => {
      if (value.stateId === state.stateId) {
        // eslint-disable-next-line no-param-reassign
        value = state;
      }
    });
    if (!states.includes(state)) {
      states.push(state);
    }
    this.scrollStates.next(states);
  }
}
